import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                  <i className="ri-fire-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-foreground-950 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
                  黑料wan网
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                汇聚全网热门黑料资讯，第一时间掌握娱乐圈、网红界最劲爆内幕信息。每日更新不间断，做最专业的吃瓜平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">热门分类</h4>
              <ul className="space-y-2">
                {categories.filter((c) => c.slug !== "all").slice(0, 4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    全部文章
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">关注我们</h4>
              <p className="text-sm text-foreground-600 mb-4">
                每日更新最新爆料，不错过任何大瓜！
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; 2026 黑料wan网 - 版权所有。本站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}